import 'bootstrap';
import 'slick-carousel';
import 'jquery.mmenu';
import 'jquery-hoverintent';
import 'lazysizes';


/// International Site Cookie
/// Carousel
/// hoverIntent Primary Nav
/// Header Scrolled
/// Mobile Menu
/// Locations Dropdown
/// Tabbed Nav
/// Super Footer Menu
/// Modal Video Override
/// Modal Within Carousel
/// UTM Address linking
/// Marketo Contact Form Redirect


/// International Site Cookie
if (document.cookie = "preferred_site1=" + decodeURIComponent('null')) {
  document.cookie = "preferred_site1=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
var regionCode = 'en-us';
if (document.documentElement.hasAttribute('data-region')) {
  if ((document.documentElement.getAttribute('data-region') != '') || (document.documentElement.getAttribute('data-region') != null)) {
   regionCode = document.documentElement.getAttribute('data-region');
  }
}
if (regionCode != 'en-us') {
  document.cookie = `preferred_region_site=${regionCode};max-age=2147483647;secure`;
} else if (window.location.href.match(/preferred_site1=en-us/i)) {
  document.cookie = `preferred_region_site=en-us;max-age=2147483647;secure`;
}

/// Carousel
$('.carousel .carousel-slides').slick({
    arrows: true,
    centerMode: true,
    centerPadding: '120px',
    infinite: true,
    slidesToShow: 1,
    variableWidth: true,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerPadding: '60px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerPadding: '20px'
          }
        }
    ]
});


/// hoverIntent Primary Nav
if (window.matchMedia("(min-width: 1024px)").matches) {
    $('.nav-item.dropdown').hoverIntent({
        timeout: 300,
        over: function() {
            $(this).addClass('-is-open').find("> .dropdown-menu").fadeIn(200);
        },
        out: function() {
            $(this).removeClass('-is-open').find("> .dropdown-menu").fadeOut(200);
        }
    });
}


/// Header Scrolled
$( window ).scroll(function() {
    if(!$(window).scrollTop()) { //abuse 0 == false :)
        $('header.primary').removeClass('scrolled');
    }
    else if ( !$('header.primary').hasClass('scrolled') ) {
        $('header.primary').addClass('scrolled');
    }
});


/// Mobile Menu
$("#mobile-menu").mmenu(
    {
        "navbars": [
            {
                "position": "top",
                "content": [
                    '<form action="/search" class="search"><div class="searchbar"><label class="sr-only" for="h-search">Search</label><input type="text" id="mm-h-search" name="q" placeholder="Search"><button type="submit" class="btn btn-primary btn-icon">Search</button></div></form>'
                ]
            }
        ],

        extensions: [
            "border-full",
            "theme-white",
            "fx-menu-fade",
            "fx-listitems-fade",
            "shadow-page",
						"position-right"
        ],
    },
    {
        clone: true
    }
);


/// Locations Dropdown
$('.locationsDropdown-select select').on('change', function() {
    var $target = $(this).find(':selected').data('target');

    $('.locationsDropdown-flag.show').removeClass('show');
    $('.locationsDropdown-content.show').removeClass('show');
    $('[data-ref="' + $target + '"]').addClass('show');
});


/// Tabbed Nav
$('.js-tabs').find('.js-tabTarget').on('click', function(e) {
    if ($(window).width() >= 1024){
        e.preventDefault();

        var $target = $(this).data('target');
        var $tabs = $(this).closest('.js-tabs').find('.js-tabTarget');
        var $tabContents  = $(this).closest('.js-tabs').find('.js-tab');

        $tabs.removeClass('active');
        $tabContents.removeClass('show');

        $(this).addClass('active');
        $tabContents.filter('[data-ref="' + $target + '"]').addClass('show');
    }
});


/// Super Footer Menu
let $footer               = $('.footer');
let $footerMenuToggle     = $('.footer .super-footer-toggle');
let $footerMenuToggleCopy = $footerMenuToggle.find('.menu-toggle-copy');

$footerMenuToggle.click(function() {
    let $footerMenuToggleText = $footerMenuToggle.data('toggletext');
    $footerMenuToggle.data('toggletext', $footerMenuToggleCopy.text());
    $footerMenuToggleCopy.text($footerMenuToggleText);

    $('html,body').animate({
        scrollTop: $footer.offset().top - $('header.primary').outerHeight()
    });
});


/// Modal Video Override
$('[data-toggle="modal"]').on('click', function(){

    // get link's modal target
    var modalTarget = $(this).data('target');

    // if modal has an iframe
    if ( !$(modalTarget).find('iframe').length == 0 ) {

        // get iframe and src
        var modalIframe = $(modalTarget).find('iframe');
        var modalIframeSrc = $(modalIframe).attr('data-src'); // Check first in case lazyloading iframe

        // If not lazyloading iframe, pull src instead of data-src
        if (typeof modalIframeSrc == 'undefined' || !modalIframeSrc) {
            modalIframeSrc = $(modalIframe).attr('src')
        }

        // set src attribute on close to ensure video stops playing
        $(modalTarget).on('hide.bs.modal', function (e) {
            $(modalIframe).attr('src', modalIframeSrc);
        });

        // set src attribute on open
        $(modalTarget).on('show.bs.modal', function (e) {
            $(modalIframe).attr('src', modalIframeSrc);
        });
    }
});


/// Modal within Carousel
$('.slick-slide:not(slick-cloned) .modal').appendTo($('.carousel'));


/// UTM Address linking
//if the address contains the string '?utm'
if ( window.location.href.indexOf("?utm") > -1 ){
    // loop through each anchor tag with 'pages.infor.com anywhere in the href
    $('a[href*="pages.infor.com"]').each(function() {
        // apply the utm query portion of the address to the pages.infor.com link
        $(this).attr("href", $(this).attr("href") + window.location.href.substring(window.location.href.indexOf("?utm")) );
    });
}


/// Tiles with Metrics - Equal hieght titles.
// Make metric font smaller if the title is more than two lines tall.
$('.tileContainer-tiles').each(function(){
    $('.metric', this).each(function(){
        if($(this).height() > 128) {
            $(this).addClass('metric-tiny');
        }
    });
});
// function to get the tallest title height and sets a min-height on all of them.
var tileContainer = () => {
    if ($(window).width() >= 768) {
        $('.tileContainer-tiles').each(function(){
            var highestBox = 0;
            $('.metric',this).css('min-height', highestBox)
            $('.metric', this).each(function(){
                if($(this).height() > highestBox) {
                    highestBox = $(this).height();
                }
            });
            $('.metric',this).css('min-height', highestBox)
        });
    } else {
        $('.tileContainer-tiles').each(function(){
            $('.metric',this).css('min-height', 0)
        });
    }
};
// run that function on start and on resize.
tileContainer();
$(window).resize(function(){
    tileContainer();
});


// COMMENTING THIS OUT AS THEY WANT TO CONTROL THE REDIRECT IN MARKETO - this seemed to be overriding that
// and the Let's Connect form and Contact Us form need to redirect to different places
//
// /// Marketo Contact Form Redirect
// MktoForms2.whenReady(function(form) {
//     form.onSuccess(function() {
//         location.href = location.origin + '/thank-you-for-connecting';
//         return false;
//     });
// });


// wrap % in span if there's a % in the metric.
if ( $('.tileShadowedContainer .metric').length ) {
    if ( $('.tileShadowedContainer .metric').text().indexOf('%') ) {
        $('.tileShadowedContainer .metric').html(function() {
            return $(this).text().replace(/%/g, '<span>%</span>');
        });
    }
}

// Apply class "layer-last-tile" to the last tile in a group of layers. This is
// so we can add padding to the last tile in a layers group so only sequential tiles have
// small spacing between them.
$('.layers .layer').each(function(){
    if ($(this).hasClass('layer-tiles') && !$(this).next().hasClass('layer-tiles')) {
        $(this).addClass('layer-tiles-last');
    }
});

// Check for animated hero modifier class ("-hero-anim")
var heroAnimEl = document.querySelector('.-hero-anim');
if (heroAnimEl) {

	var headlineEl = heroAnimEl.querySelector('[data-hero-headline]');
	var headlineWords = headlineEl.innerText.split(' ');
	headlineEl.innerHTML = '';

	for (var i = 0; i < headlineWords.length; i++) {

		let word = headlineWords[i];
		let wordEl = document.createElement('div');
		let chars = word.split('');

		for (var j = 0; j < chars.length; j++) {

			let char = chars[j];
			let charEl = document.createElement('span');
			charEl.innerHTML = char;
			wordEl.appendChild(charEl);

		}

		headlineEl.appendChild(wordEl);

	}

	setTimeout(function() {
    heroAnimEl.classList.add('-hero-anim-active')
  }, 500);

} 

function consentCheckStatus(group) {

	if (typeof OptanonActiveGroups === 'string') {

		var groups = OptanonActiveGroups.split(',');

		for (var i = 0; i < groups.length; i++) {
			if (groups[i] === group) {
				return true;
			}
		}

	}

}

function getUrlParam(name) {
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
			results = regex.exec(location.search);
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function populateUTMFields(formEl) {

	var utmCodeArr = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_type', 'utm_adgroup', 'utm_keyword'];

	for (var i = 0; i < utmCodeArr.length; i++) {

		var utmCode = utmCodeArr[i];
		var utmFieldEl = formEl.querySelector('input[name="' + utmCode + '"]');

		if((getUrlParam(utmCode)) && utmFieldEl) {
			utmFieldEl.value = getUrlParam(utmCode);
		}


	}

}


function validateFields(els) {

	var isValid = true;
	var reqFieldEls = els;

	for (var i = 0; i < reqFieldEls.length; i++) {

		var fieldEl = reqFieldEls[i];
		var controlEl = fieldEl.querySelector('[data-control]');

		
		if (window.getComputedStyle(fieldEl).display != 'none') {

			if (controlEl.value) {

				// remove error
				fieldEl.classList.remove('field--error');

				// check if control type is email
				if (controlEl.getAttribute('type') == 'email') {

					if(validateEmail(controlEl.value)) {

						// remove error
						fieldEl.classList.remove('field--error');

					} else {

						// add error
						fieldEl.classList.add('field--error');

						isValid = false;

					}

				}

			} else {

				// throw error
				fieldEl.classList.add('field--error');

				isValid = false;

			}

		} else {
			
			if(fieldEl.classList.contains('field--error')) {
				fieldEl.classList.remove('field--error');
			}
			
		}

	}

	return isValid;

}

function validateEmail(input) {

	var pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

	return pattern.test(input);

}

function validateForm(el, callback) {

	// add submit handler
	el.addEventListener('submit', function(ev) {

		// disable html validation
		el.setAttribute('novalidate', 'novalidate');

		// validate fields
		if (validateFields(el.querySelectorAll('[data-field="required"]'))) {
			if (callback && typeof callback === 'function') {
					callback(el);
			}
		}
		// prevent form from submitting
		ev.preventDefault();
	})
}

function postRequest(el, onSuccess, onError) {

	var request = new XMLHttpRequest();

	var data = new FormData(el);

	// initialize request
	request.open('POST', el.action, true);

	// get response
	request.onload = function(response) {

		if (request.status === 200) {

			// callback for success
			if (onSuccess && typeof onSuccess === 'function') {
				onSuccess();
			}

			// check consent group status
			if (consentCheckStatus('C0004')) {
				createHiddeniFrame(el,data);
			}
		
		} else {

			// callback for error
			if (onError && typeof onError === 'function') {
				onError();
			}

		}

	}

	// send data
	request.send(data);

}

function getParam(p) {
	var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
	return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
function getExpiryRecord(value) {
	var expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds
	var expiryDate = new Date().getTime() + expiryPeriod;
	return {
		value: value,
		expiryDate: expiryDate
	};
}
function addGclid(field) {

	var gclidParam = getParam('gclid');
	var gclidRecord = null;
	
	var gclsrcParam = getParam('gclsrc');
	var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;
	
	if (gclidParam && isGclsrcValid) {
		gclidRecord = getExpiryRecord(gclidParam);
		localStorage.setItem('gclid', JSON.stringify(gclidRecord));
	}
	
	var gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
	var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;
	
	if (field && isGclidValid) {
		field.value = gclid.value;
	}

	// USE FOR TESTING: field.value = gclidParam;
}

function formatFormDataToObj(el) {

	var formData = {},
			fieldEls = el.querySelectorAll('[data-control]');

	for (var i = 0; i < fieldEls.length; i++) {

		var fieldEl = fieldEls[i],
				fieldName = fieldEl.name,
				fieldValue = fieldEl.value;

		if (fieldValue) {
			formData[fieldName] = fieldValue
		}

	}

	return formData;

}

function convertJSONToQueryString(data) {

	var formObj = {};
	data.forEach(function(value, key) {
		formObj[key] = value;
	});

	var formattedData = formObj;
	var queryString = '';

	for (var key in formattedData) {
		if ((key === 'email') || (key === 'Email') || (key === 'firstName') || (key === 'lastName')) {
			queryString += key + '=' + encodeURIComponent(formattedData[key]) + "&"
		}
	}

	return queryString;

}

function createHiddeniFrame(el, data) {

	var iframeEl = document.createElement('iframe');
	var formURL = el.querySelector('input[name="pardotURL"]').value;
	var queryString = convertJSONToQueryString(data);

	iframeEl.src = 'https://go.infor.com/l/950892/2022-05-20/26kwgg' + '?' + queryString.slice(0, -1);
	iframeEl.style.height = '1px';
	iframeEl.style.opacity = '0';
	iframeEl.style.width = '1px';

	el.parentNode.insertBefore(iframeEl, el);

}

function mapFieldsForSubmission(el) {

	var fieldsArr = [];
	var mappingInputEl = el.querySelector('input[name="mapPardot"]');

	// gather all hidden input els
	var hiddenInputEls = el.querySelectorAll('input[type="hidden"]');
	for (var i = 0; i < hiddenInputEls.length; i++) {
		if((hiddenInputEls[i].name != 'CRAFT_CSRF_TOKEN') && (hiddenInputEls[i].name != 'mapPardot') && (hiddenInputEls[i].name != 'pardotURL')) {
			fieldsArr.push(hiddenInputEls[i].name);
		}
	}

	// gather all visible field els
	var fieldEls = el.querySelectorAll('[data-field]');
	for (var i = 0; i < fieldEls.length; i++) {
		if (window.getComputedStyle(fieldEls[i]).display != 'none') {
			var controlEl = fieldEls[i].querySelector('.field-control');
			if (fieldsArr.indexOf(controlEl.name) === -1) {
				fieldsArr.push(controlEl.name);
			}
		}
	}

	// update mapping input el with field values
	var fieldValues = fieldsArr.join('|');
	mappingInputEl.value = fieldValues;

}

function PardotFormHandler(el) {

	// Collect Elements to hide after submission
	var hideElements = document.querySelectorAll('[data-hide-after-submission]');

	var successMsg = el.getAttribute('data-success-msg');
	if (successMsg) {
		var successMsgEl = document.createElement('div');
		successMsgEl.classList.add('form-notice', 'form-notice--success');
		successMsgEl.setAttribute('data-form-success-notice','');
		successMsgEl.innerHTML = `
			<p>${successMsg}</p>
		`;
	}

	var errorMsg = el.getAttribute('data-error-msg');
	if (errorMsg) {
		var errorMsgEl = document.createElement('div');
		errorMsgEl.classList.add('form-notice', 'form-notice--error');
		errorMsgEl.setAttribute('data-form-error-notice','');
		errorMsgEl.innerHTML = `
			<p>${errorMsg}</p>
		`;
	}

	var isGatedResource = false;
	var formType = el.getAttribute('data-form-type');

	if (formType) {
		if (el.getAttribute('data-form-type') === 'gated') {
			isGatedResource = true;
		}
	}

	var isRedirectEnabled = false;

	if (el.hasAttribute('data-redirect-url')) {
		isRedirectEnabled = true;
	}

	// check for Drift campaign
	var hasDriftCampaign = false;
	var driftCampaignID = '';
	if (el.hasAttribute('data-drift-campaign-id')) {
		hasDriftCampaign = true;
		driftCampaignID = el.getAttribute('data-drift-campaign-id');
	}

	// populate GCLID field
	var GclidEl = el.querySelector('[name="gclid_field"]');
	if (GclidEl) {
		addGclid(GclidEl);
	}

	// run validation
	validateForm(el, function(formEl) {

		// populate any UTM fields
		populateUTMFields(el);

		// build mapping field
		mapFieldsForSubmission(el);

		// define data layer
		window.dataLayer = window.dataLayer || [];

		// if Drift campaign, prevent form from submitting initially and push data to Drift API
		// comment comment comment
		if (hasDriftCampaign) {

			var formData = formatFormDataToObj(formEl);

			drift.api.collectFormData(formData, {
				campaignId: parseInt(driftCampaignID)
			});
			// i don't know how you broke this branch
			drift.on('conversation:firstInteraction', function(data) {
				if (el.querySelector('input[name="hasInteractedWithDrift"]')) {
					el.querySelector('input[name="hasInteractedWithDrift"]').value = 'true';
				}
			});
			// but it doesn't merge unless I put comments in; 
			// a comment at line 654 didn't do it, so now I've wrapped your new code in comments
			drift.on('chatClose', function() {
				
				postRequest(el, 
					function() {
		
						// push event to data layer (for tracking)
						window.dataLayer.push({'event': 'form_submit', 'form_name': formEl.getAttribute('data-pardot-form')});
						
						// append success msg (but ignore on gated resource)
						if (successMsg && !isGatedResource) {
							el.parentNode.insertBefore(successMsgEl, el);
						}
		
						// if success msg, scroll to message el (offset sticky header)
						if (successMsg) {
							window.scrollTo({
								top: document.querySelector('[data-form-success-notice]').getBoundingClientRect().top + window.pageYOffset - 85, 
								behavior: 'smooth'
							})
						}
		
						// hide form el
						el.style.display = 'none';
					
					}, 
					function() {
						console.log('Error in submission');
		
						// append error msg
						if (errorMsg) {
		
							if(!el.hasAttribute('data-form-submission-error')) {
								el.parentNode.insertBefore(errorMsgEl, el);
								el.setAttribute('data-form-submission-error','');
							}
							
						}
		
					});

			});

			return false;
		}

		postRequest(el, 
			function() {
				console.log('Successful submission');

				// push event to data layer (for tracking)
				window.dataLayer.push({'event': 'form_submit', 'form_name': formEl.getAttribute('data-pardot-form')});

				// append success msg (but ignore on gated resource)
				if (successMsg && !isGatedResource && !isRedirectEnabled) {
					el.parentNode.insertBefore(successMsgEl, el);
				}

				// if gated resource, show resource
				if (isGatedResource) {
					document.body.querySelector('[data-gated-resource]').style.display = 'block';
					document.body.querySelector('[data-gated-resource-description]').style.display = 'none';
					document.body.querySelector('[data-gated-title]').style.display = 'none';

					if (formEl.getAttribute('data-asset-download') === 'immediate') {
						if (document.body.querySelector('[data-gated-resource] .btn--download')) {
							document.body.querySelector('[data-gated-resource] .btn--download').setAttribute('target', '_blank');
							document.body.querySelector('[data-gated-resource] .btn--download').click();
					  }
					}
				}

				if (isRedirectEnabled) {
					el.parentNode.insertBefore(successMsgEl, el);
					setTimeout(function () {
						window.location.href = el.getAttribute('data-redirect-url');
					}, 4000);
						// hide form elements
						if (hideElements) {
							for (var i = 0; i < hideElements.length; i++) {
								hideElements[i].style.display = 'none';
							}
						}
				}

				// if success msg, scroll to message el (offset sticky header)
				if (successMsg && !isGatedResource) {
					window.scrollTo({
						top: document.querySelector('[data-form-success-notice]').getBoundingClientRect().top + window.pageYOffset - 85, 
						behavior: 'smooth'
					})
				}
				
				// hide form el
				el.style.display = 'none';
			
			}, 
			function() {
				console.log('Error in submission');

				// append error msg
				if (errorMsg) {

					if(!el.hasAttribute('data-form-submission-error')) {
						el.parentNode.insertBefore(errorMsgEl, el);
						el.setAttribute('data-form-submission-error','');
					}
					
				}

			});

	});

}

// Initialize Pardot form handler on form el's
var formEls = document.querySelectorAll('[data-pardot-form]');
if (formEls) {
	for (var i = 0; i < formEls.length; i++) {
		var formEl = formEls[i];
		PardotFormHandler(formEl);
	}
}





// WEBPACK FOOTER //
// ./resources/assets/js/main.js